import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function TutorDatabaseAdminTwo() {
  const [allApplications, setAllApplications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [query, setQuery] = useState(""); // State to store the query
  const [area, setArea] = useState(""); // Default area
  const [selectedSubArea, setSelectedSubArea] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [religion, setReligion] = useState("");
  const [hscSubject, setHscSubject] = useState("");
  const [honsSubject, setHonsSubject] = useState("");
  const [honsSemester, setHonsSemester] = useState("");
  const [mastersSubject, setMastersSubject] = useState("");
  const [mastersSemester, setMastersSemester] = useState("");
  const [total, setTotal] = useState("");

  useEffect(() => {
    const savedPage = parseInt(localStorage.getItem("currentPage")) || 1;
    setCurrentPage(savedPage);
  }, []);

  useEffect(() => {
    fetchApplications();
    // Save currentPage to localStorage whenever it changes
    localStorage.setItem("currentPage", currentPage.toString());
  }, [currentPage]);

  const fetchApplications = async () => {
    setLoading(true);
    const limit = 10; // Set the limit for items per page
    try {
      const response = await fetch(
        `https://tutor-tree-server-1.vercel.app/AllTutorsMainDataStreamPagination?email=${encodeURIComponent(
          email
        )}&area=${encodeURIComponent(
          area
        )}&selectedSubArea=${encodeURIComponent(
          selectedSubArea
        )}&gender=${encodeURIComponent(gender)}&religion=${encodeURIComponent(
          religion
        )}&hscSubject=${encodeURIComponent(
          hscSubject
        )}&honsSubject=${encodeURIComponent(
          honsSubject
        )}&mastersSubject=${encodeURIComponent(
          mastersSubject
        )}&honsSemester=${encodeURIComponent(
          honsSemester
        )}&mastersSemester=${encodeURIComponent(
          mastersSemester
        )}&page=${currentPage}`
      );
      if (!response.ok) throw new Error("Network response was not ok");
      const result = await response.json();
      console.log("r", response);
      setAllApplications(result.data.reverse());
      setTotalPages(Math.ceil(result.total / limit));
      setTotal(result.total);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Reset to the first page whenever filters change
    setCurrentPage(1);
    fetchApplications();
  }, []); // Add other filter dependencies as needed

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearch = () => {
    setCurrentPage(1); // Optional: Reset to the first page on search
    fetchApplications(); // Fetch applications based on the current search query and other filters
  };

  const handleClear = () => {
    // Reset search criteria and other filters
    setQuery("");
    setEmail("");
    setArea("");
    setGender("");
    setReligion("");
    setHscSubject("");
    setHonsSubject("");
    setMastersSubject("");
    setSelectedSubArea("");
    setMastersSemester("");
    setHonsSemester("");
    setCurrentPage(1); // Reset to the first page
    fetchApplications(); // Fetch initial applications
  };

  // ADDING SELECT DATA

  const [districts, setDistricts] = useState([]);

  const fetchDistricts = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/allDistrict");
      const data = await response.json();
      setDistricts(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchDistricts();
  }, []);

  // In your select element

  // area

  const [KhulnaArea, setKhulnaArea] = useState([]);
  const [ChittagongArea, setChittagongArea] = useState([]);
  const [DhakaArea, setDhakaArea] = useState([]);

  // State for the selected area and sub-area

  // Fetch area data
  useEffect(() => {
    const fetchAreaData = async () => {
      // Fetch Khulna Area Data
      try {
        let response = await fetch("https://tutor-tree-server-1.vercel.app/khulnaArea");
        let data = await response.json();
        setKhulnaArea(data);
      } catch (error) {
        console.error("Error fetching Khulna Area:", error);
      }

      // Fetch Chittagong Area Data
      try {
        let response = await fetch("https://tutor-tree-server-1.vercel.app/ChittagongArea");
        let data = await response.json();
        setChittagongArea(data);
      } catch (error) {
        console.error("Error fetching Chittagong Area:", error);
      }

      // Fetch Dhaka Area Data
      try {
        let response = await fetch("https://tutor-tree-server-1.vercel.app/DhakaArea");
        let data = await response.json();
        setDhakaArea(data);
      } catch (error) {
        console.error("Error fetching Dhaka Area:", error);
      }
    };

    fetchAreaData();
  }, []);

  // Determine which sub-area data to use based on the selected area
  const getSubAreaData = () => {
    switch (area) {
      case "Chittagong":
        return ChittagongArea;
      case "Khulna":
        return KhulnaArea;
      case "Dhaka":
        return DhakaArea;
      default:
        return [];
    }
  };

  // box
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const optionsSubjectsHons = [
    "Automobile",
    "Petroleum and Mining Engineering",
    "Fabric Manufacturing",
    "Power Supply",
    "Electronics & Communication Engineering (ECE)",
    "Agricultural Chemistry",
    "Home Economics",
    "Disaster Management",
    "Dentistry",
    "Fisheries and Aquaculture",
    "English Literature",
    "Agricultural Engineering and Technology",
    "Printing and Publication Studies",
    "Telecommunication Engineering",
    "English and Humanities",
    "Dance",
    "Music",
    "Physical Education and Sports Science",
    "Art and Creative Studies",
    "Software Engineering (SWE)",
    "Computer Technology",
    "Psychology",
    "Data Telecommunication and Networking",
    "Al-Quran",
    "Industrial Relations and Labour Studies",
    "Agronomy",
    "Geography",
    "Leather Engineering",
    "Plant Pathology",
    "Islamic History and Culture",
    "Agriculture",
    "Pharmaceutical Chemistry",
    "LLM",
    "English Language Teaching (ELT)",
    "Computer Science (CS)",
    "Applied Accounting",
    "Craft",
    "Bank Management",
    "Naval Architecture and Marine Engineering (NAME)",
    "Arabic",
    "Literature and Culture Studies",
    "Fisheries",
    "Electrical and Electronic Engineering (EEE)",
    "Electronics Technology",
    "Instrumental Music",
    "Climate Change and Development (CCD)",
    "Fisheries Science",
    "History",
    "Electronics",
    "Food and Nutrition",
    "Social Science",
    "Social Work",
    "Health Economics",
    "Peace and Conflict Studies",
    "Theoretical Physics",
    "Management Information Systems (MIS)",
    "Computer Engineering (CoE)",
    "Resource Management and Entrepreneurship",
    "Graphic Design",
    "Maritime Science",
    "Pharmaceutical Technology",
    "Entrepreneurship",
    "Anthropology",
    "Nuclear Engineering",
    "Organic Chemistry",
    "Sculpture",
    "Applied Chemistry and Chemical Engineering",
    "English Literature and Language",
    "Geography and Environment",
    "Public Health",
    "Geography and Environmental Studies",
    "Media Studies and Journalism",
    "Theoretical and Computational Chemistry",
    "Electronics and Telecommunication Engineering (ETE)",
    "English",
    "ACCA (the Association of Chartered Certified Accountants)",
    "Law and Justice",
    "Finance and Banking",
    "Pharmacology",
    "Industrial and Production Engineering (IPE)",
    "Oceanography",
    "Applied Mathematics",
    "Soil Science",
    "Business Studies",
    "Criminology",
    "Public Administration",
    "Chemistry",
    "Banking and Insurance",
    "Mathematics",
    "Sociology",
    "Geology",
    "Management",
    "Political Science",
    "Human Resource Management (HRM)",
    "Humanities",
    "Cachion Docianing and Technology",
    "Oriental Art",
    "Architecture",
    "International Relations (IR)",
    "Child Development and Social Relationship",
    "Supply Chain Management",
    "Civil Technology",
    "Shipbuilding Technology",
    "Arabic Language",
    "Hadith",
    "Fashion Designing and Technology (FDT)",
    "Physics",
    "Biochemistry",
    "Japanese Studies",
    "Information and Communication Engineering (ICE)",
    "Information and Communication Technology (ICT)",
    "Rabindra Sangeet",
    "ACCA",
    "Printmaking",
    "Agricultural Economics",
    "Economics",
    "Aeronautical Engineering",
    "Law",
    "Mechanical Engineering (ME)",
    "Building Engineering and Construction Management",
    "Physiotherapy",
    "Power Technology",
    "General",
    "Public Health and Informatics",
    "Accounting and Information Systems (AIS)",
    "Sanskrit",
    "Civil and Environmental Engineering (CEE)",
    "Microbiology",
    "Finance",
    "Nazrul Sangeet",
    "Statistics",
    "Apparel Manufacture and Technology (AMT)",
    "Marine Science",
    "Drawing and Painting",
    "Glass and Ceramic Engineering (GCE)",
    "Apparel Merchandising Management & Technology",
    "Education and Research (ER)",
    "Organization Strategy and Leadership (OSL)",
    "Tourism and Hospitality Management (THM)",
    "International Business (IB)",
    "World Religion and Culture (WRC)",
    "Theater and Music",
    "Languages and Linguistics",
    "Sanskrit and Pali",
    "Port Management and Logistics (PML)",
    "Disaster and Human Security Management (DHSM)",
    "Clothing and Textile",
    "Materials Science and Engineering (MSE)",
    "LLB",
    "Development Studies",
    "Information Technology (IT)",
    "Accounting",
    "Marketing",
    "Marine Tourism and Hospitality Management (MTHM)",
    "Maritime Law (ML)",
    "Port & Shipping Management (PSM)",
    "Environmental Technology Engineering (ETE)",
    "Materials and Metallurgical Engineering (MME)",
    "Disaster Resilience and Sustainable Development (DRSD)",
    "Electronic and Telecom Engineering (ETE)",
    "Environmental Science and Management (ESM)",
    "Environmental and Resource Management (ERM)",
    "Nuclear Power Engineering (NPE)",
    "Disaster Prevention and Urban Safety (DPUS)",
    "Water and Flood Management (WFM)",
    "Communication Disorders",
    "Mass Communication and Journalism (MCJ)",
    "Biomedical Physics and Technology (BPT)",
    "Clinical Pharmacy and Pharmacology (CPP)",
    "Pharmacy",
    "History of Art",
    "Dobotics and Mechatronics",
    "Civil Engineering (CE)",
    "Urban and Rural Planning (URP)",
    "Urban and Regional Planning (URP)",
    "Architecture & Interior Design Technology (AIDT)",
    "Architecture (Arch)",
    "Meteorology",
    "Geography and Environmental Science (GES)",
    "Television, Film and Photography",
    "Disaster Management and Vulnerability Studies (DMVS)",
    "Disaster Science and Management (DSM)",
    "Disaster Science & Management (DSM)",
    "Electromedical Engineering",
    "Electrical & Power Engineering (EPE)",
    "Energy Technology",
    "Naval Architecture and Offshore Engineering (NAOE)",
    "Robotics and Mechatronics Engineering (RME)",
    "Nuclear Science and Engineering (NSE)",
    "Educational Psychology",
    "Plant Breeding",
    "Genetic Engineering and Biotechnology (GEB)",
    "Medical Psychology",
    "Biochemistry and Molecular Biology (BMB)",
    "Petroleum and Mineral Resources Engineering (PMRE)",
    "Craft and Material Studies (CMS)",
    "Materials and Metallurgical Engineering (MME)",
    "Chemical Engineering (ChE)",
    "Mechanical and Chemical Engineering (MCE)",
    "Biomedical Engineering (BME)",
    "Water Resources Engineering (WRE)",
    "Computer Science and Engineering (CSE)",
    "Veterinary Medicine",
    "Agribusiness",
    "Textile Engineering (TE)",
    "Pathology",
    "Forensic Medicine",
    "Community Medicine",
    "Physiology",
    "Anatomy",
    "Mechatronics Engineering (ME)",
    "Classical Music",
    "Radiography",
    "Biochemistry and Biotechnology",
    "Folk Music",
    "Leather Products Engineering",
    "Recourse Management and Entrepreneurship (RME)",
    "Electronic and Telecom Engineering",
    "Biochemistry and Microbiology",
    "Alema",
    "Islamic Studies",
    "Mawlana",
    "Physical Science",
    "Soil, Water and Environment",
    "Finance and Marketing (Double Major)",
    "Zoology",
    "Takmil",
    "Computer Crionco and Insincorina",
    "Interior Architecture",
    "Building Engineering and Construction Management (BECM)",
    "Mechanical and Production Engineering (MPE)",
    "Fabric Engineering",
    "Marhalatul Mutawassitah",
    "Marhala Sanabiah Ulaiya",
    "Marhalatul Fadilat",
    "Geological Sciences",
    "Petroleum & Mining Engineering (PME)",
    "Hifzul Quran",
    "Mufti",
    "Dinajpur Zilla School",
    "Theology and Islamic Studies",
    "Chinese Language and Culture",
    "Electronics and Communication Engineering (ECE)",
    "Information Studies and Library Management",
    "Applied Physics, Electronics and Communication Engineering",
    "Environmental Science (ES)",
    "Holy Quran and Sunnah",
    "Industrial Engineering and Management (IEM)",
    "Law and Human Rights",
    "Architecture Technology",
    "French Language",
    "Computer Information Management (CIM) and Accounting",
    "General Electronics",
    "Dress Making",
    "Tafhim-ul-Quran",
    "Business and Technology Management (BTM)",
    "Moallim",
    "Marine Bio-Resource Science",
    "Applied Linguistics",
    "Dawaa and Civilization",
    "Horticulture",
    "North Indian Classical Music",
    "Islamic Law",
    "Botany",
    "Biotechnology",
    "Marine Bio-Resources Science",
    "Apparel Manufacturing and Management (AMM)",
    "Applied Nutrition and Food",
    "Islamic History",
    "Ispahani Public School and College",
    "Apparel Merchandising",
    "Al-Quran and Islamic Studies",
    "Marketing and Management",
    "Information System (MIS)",
    "Management Studies",
    "Genetics and Plant Breeding (GPB)",
    "Finance and Economics (Double Major)",
    "Photography",
    "Tabla",
    "Nanoscience and Nanotechnology",
    "Management Information Systems (MIS) and Finance (Double Major)",
    "Architecture and Interior Design Technology",
    "Management and Marketing (Double Major)",
    "Management of Technology (MOT)",
    "Computer",
    "Agrotechnology",
    "Agroforestry and Environmental Science",
    "Earth and Environmental Science (EES)",
    "Applied Statistics and Data Science (MSDS)",
    "Electrical Technology",
    "Clinical Pharmacy and Molecular Pharmacology",
    "Education",
    "Philosophy",
    "Veterinary and Animal Science",
    "Agribusiness and Marketing",
    "Applied Physics and Electronics (APE)",
    "Finance and Accounting",
    "Agronomy and Agricultural Extension",
    "English Literature and Theory",
    "Industrial-Organizational Psychology",
    "Chemical Engineering and Polymer Science (CEPS)",
    "Textile Machinery Design and Maintenance",
    "Human Resource Management (HRM) and Economics, Double Major",
    "Human Resource Management (HRM)",
    "International Business (IB), Double Major",
    "Electronics and Communication Engineering (ECE) and Applied Physics",
    "Electrical Engineering",
    "Advanced Engineering Management",
    "Finance and Human Resource Management (HRM)",
    "Jamia Arabia Imdadul Uloom",
    "Faridabad Madrasah",
    "Islamic Philology",
    "Biochemistry and Cell Biology",
    "Al-Hadith and Islamic Studies",
    "Telecommunication Technology",
    "Fashion Design and Technology (FDT)",
    "Computer Operation",
    "Java SE-8",
    "Electrical and Computer Engineering (ECE)",
    "Multimedia and Creative Technology (MCT)",
    "Management and Marketing (Double Major)",
    "Environmental and Resource Economics",
    "Strategic International Management",
    "Economics and Marketing (Double Major)",
    "Wet Processing Engineering (WPE)",
    "Finance and Accounting (Double Major)",
    "Cost and Management Accounting",
    "Drama and Dramatics",
    "Spanish Language",
    "Digital Business and Innovation (DBI)",
    "Renewable Energy Technology (RET)",
    "Craft and Fashion Design",
    "Women and Gender Studies",
    "Physical Chemistry",
    "Biotechnology and Genetic Engineering (BGE)",
    "Government and Politics",
    "Refrigeration and Air-Conditioning Technology",
    "Civil and Water Resources Engineering",
    "Industrial Engineering (IE)",
    "Chemical Engineering and Technics",
    "Biotechnology and Genetic Engineering (BTE)",
    "Mechanical and Electrical Engineering (MEE)",
    "Computer and Information Technology",
    "General Science",
    "Entomology",
    "Criminology and Police Science",
    "Arabic Language and Islamic Studies",
    "Modern Nazrana",
    "Film and Television",
    "Footwear Engineering",
    "Common Law",
    "Economics and Banking (EB)",
    "Accounting and Marketing (Double Major)",
    "Applied Physics and Electronic Engineering (APEE)",
    "Aeronautical Engineering (AE)",
    "Aerospace Engineering",
    "Apparel Manufacturing and Technology (AMT)",
    "Applied Physics, Electronics and Communication Engineering (APECE)",
    "Bangladesh Studies",
    "Human Rights Law",
    "English for Speakers of Other Languages (ESOL)",
    "Garments Design And Pattern Making Technology",
    "Nutrition and Food Engineering (NFE)",
    "Structural Engineering",
    "Graphic Design and Multimedia (GDM)",
    "Gynecology",
    "Apparel Engineering (AE)",
    "Electrical Electronic and Communication Engineering (EECE)",
    "Control, Microsystems, Microelectronics (CMM)",
    "Human Resource Management (HRM) and Supply Chain Management (Double Major)",
    "Electrical Mechatronics (EM)",
    "Medicine and Surgery",
    "Disaster Management and Resilience (DMR)",
    "Bangladesh MHM School",
    "Population Science and Human Resource Development (PSHRD)",
    "Forestry and Environmental Science",
    "Archaeology",
    "Dyes and Chemical Engineering (DCE)",
    "Human Resource Management (HRM) and Marketing (Double Major)",
    "Human Resource Management (HRM) and Accounting (Double Major)",
    "International Business (IB) and Marketing (Double Major)",
    "Computer and Information System (CIS)",
    "English Language and Literature (ELL)",
    "Inorganic Chemistry",
    "Quranic Sciences and Islamic Studies (QSIS)",
    "French Language and Culture (FLC)",
    "Population and Public Health Sciences (PPHS)",
    "Fisheries and Marine Resources Technology",
    "Coastal and Marine Science",
    "Electro-Medical Technology (EMT)",
    "Textile Engineering and Management",
    "Computer Science and Telecommunication Engineering",
    "History and Civilization",
    "Linguistics",
    "Textile Engineering (Fashion and Design)",
    "Computer and Communication Engineering (CCE)",
    "Development Economics",
    "Knitwear Industry Management",
    "Agribusiness Management",
    "Bioinformatics Engineering",
    "Information Technology and Management (ITM)",
    "Mechanical Technology",
    "Nursing Science and Midwifery",
    "Nursing",
    "Science, Mathematics and Technology Education (SMTE)",
    "Arabic Language and Literature",
    "Arabic Studies",
    "Population Sciences",
    "Apparel Merchandising Management and Technology",
    "Biomedical Science",
    "Environmental Health and Safety",
    "Audiology and Speech Language Pathology (ASLP)",
    "Marine Fisheries",
    "English Language and Linguistics",
    "English and Modern Languages",
    "Health Technology",
    "Construction Engineering",
    "Aeronautical and Aviation Science & Engineering",
    "Microbiology and Immunology",
    "Special and Inclusive Education",
    "Public Health Administration",
    "Quranic Crioncos and Islamic Studios",
    "Earth and Ocean Science",
    "Energy Science and Engineering (ESE)",
    "Pali and Buddhist Studies",
    "Civil and Geotechnical Engineering",
    "Aviation Law",
    "Geotechnical Engineering",
    "Islamic Finance",
    "English Language Teaching and Applied Linguistics",
    "Mathematical and Physical Sciences (MPS)",
    "Banking",
    "Laboratory Technology",
    "Leather Engineering and Technology",
    "Science",
    "Biological Data Science",
    "Business Information Technology",
    "Energy Technology and Management",
    "Applied Statistics",
    "Apparel Manufacturing Management and Technology (AMMT)",
    "Environmental Science and Disaster Management (ESDM)",
    "Clinical Psychology",
    "Mechanical Engineering/Mechatronics (MEng)",
    "General Mechanics",
    "Garment Business (GB)",
    "Applied and Computational Mathematics (ACM)",
    "Apparel Merchandising and Management (AMM)",
    "Dawah and Islamic Studies (DIS)",
    "Bioinformatics in Biotechnology",
    "Bangla",
    "Computer Operation and Maintenance",
    "Sciences of Hadith and Islamic Studies (SHIS)",
  ];

  ///////////// subjects Hons

  return (
    <div>
      <div className="sticky top-0 bg-white border-t-2 border-orange-500">
        <div className="w-full b lg:h-20 sm:h-24 flex lg:items-center lg:flex-row sm:flex-col justify-between border-b-2 sticky top-0 border-orange-100">
          <div className="sm:my-3 flex flex-row justify-between w-full">
            <div className="flex flex-row justify-center items-center">
              <div className="flex flex-row">
                <h1 className="headerText w-20">All Tutors</h1>
                <h1 className="headerText mr-5">{total}</h1>
              </div>
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="input input-bordered input-warning w-full max-w-xs"
              />
              <div className="ml-2 flex flex-row">
                <button className="TableHeaderText" onClick={handleSearch}>
                  Search
                </button>
                <button className="ml-3 tableBodyText" onClick={handleClear}>
                  Clear
                </button>
              </div>
            </div>

            <div className="sm:flex lg:inline-flex sm:justify-end">
              <button
                onClick={toggleDropdown}
                className="filterButton lg:w-32 sm:w-24 h-10 mr-5 hover:bg-orange-700 transition duration-300 ease-in-out "
              >
                {isOpen ? (
                  <svg
                    class="h-5 w-5 text-gray-200"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    {" "}
                    <line x1="18" y1="6" x2="6" y2="18" />{" "}
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="14"
                    viewBox="0 0 16 14"
                    fill="none"
                  >
                    <path
                      d="M15.1447 0.263987C15.0687 0.102808 14.9065 0 14.7283 0H0.460361C0.282181 0 0.12002 0.102808 0.0439732 0.263987C-0.0320126 0.425165 -0.00819801 0.615682 0.105167 0.753169L5.58996 7.40555V13.5397C5.58996 13.6989 5.67227 13.8469 5.80755 13.9308C5.88169 13.9768 5.96584 14 6.05029 14C6.12008 14 6.19011 13.9841 6.25468 13.9521L9.33635 12.4247C9.49292 12.3472 9.59199 12.1876 9.59223 12.0129L9.59825 7.40574L15.0833 0.753107C15.1968 0.615682 15.2206 0.425104 15.1447 0.263987ZM8.78302 6.94737C8.7152 7.02961 8.67801 7.13291 8.67788 7.23959L8.67199 11.7265L6.51069 12.7977V7.2402C6.51069 7.13334 6.47356 7.0298 6.40555 6.94737L1.43652 0.920608H13.7521L8.78302 6.94737Z"
                      fill="white"
                    />
                  </svg>
                )}

                <span className="filterText ">
                  {" "}
                  {isOpen ? "Close" : "Filter"}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="w-full filterBackground  shadow-xl sticky top-20 flex flex-col rounded px-10 py-5">
          <div className="w-full m-2 0 grid grid-cols-3 gap-5 place-items-center">
            <select
              className="select select-warning w-full "
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              placeholder="Area"
            >
              <option value="">Gender</option>
              <option className="text-orange-900" value="male">
                Male
              </option>
              <option className="text-orange-900" value="female">
                female
              </option>
              <option className="text-orange-900" value="any">
                Any
              </option>
            </select>
            <select
              className="select select-warning w-full "
              value={religion}
              onChange={(e) => setReligion(e.target.value)}
              placeholder="Area"
            >
              <option value="">Religion</option>
              <option value="Islam">Islam</option>
              <option value="Hinduism">Hinduism </option>
              <option value="Buddhism">Buddhism</option>
              <option value="Christianity">Christianity</option>
            </select>
            <select
              className="select select-warning w-full "
              value={hscSubject}
              onChange={(e) => setHscSubject(e.target.value)}
              placeholder="Area"
            >
              <option value="">HSC Subject</option>
              <option value="science">Science</option>
              <option value="arts">Arts</option>
              <option value="commerce">commerce</option>
            </select>
            <select
              className="select select-warning w-full "
              value={honsSubject}
              onChange={(e) => setHonsSubject(e.target.value)}
              placeholder="Area"
            >
              <option value="">Select Hons Subject</option>
              {optionsSubjectsHons.map((subject) => (
                <option className="text-orange-900" value={subject}>
                  {subject}
                </option>
              ))}
            </select>
            <select
              className="select select-warning w-full "
              value={honsSemester}
              onChange={(e) => setHonsSemester(e.target.value)}
              placeholder="Area"
            >
              <option value="">HSC Semester</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
            </select>
            <select
              className="select select-warning w-full "
              value={mastersSemester}
              onChange={(e) => setMastersSemester(e.target.value)}
              placeholder="Area"
            >
              <option value="">Masters Semester</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
            </select>
            <select
              className="select select-warning w-full "
              value={mastersSubject}
              onChange={(e) => setMastersSubject(e.target.value)}
              placeholder="Area"
            >
              <option value="">Select Masters Subject</option>
              {optionsSubjectsHons.map((subject) => (
                <option className="text-orange-900" value={subject}>
                  {subject}
                </option>
              ))}
            </select>
            <select
              className="select select-warning w-full "
              value={area}
              onChange={(e) => setArea(e.target.value)}
              placeholder="Area"
            >
              <option value="">Select Area</option>
              {districts.map((district) => (
                <option
                  className="text-orange-900"
                  key={district.id}
                  value={district.district}
                >
                  {district.district}
                </option>
              ))}
            </select>
            {area && (
              <select
                className="select select-warning w-full "
                value={selectedSubArea}
                onChange={(e) => setSelectedSubArea(e.target.value)}
              >
                <option value="">Select Sub-Area</option>
                {getSubAreaData().map((subArea) => (
                  <option value={subArea.area}>{subArea.area}</option>
                ))}
              </select>
            )}
          </div>
          <div className="my-5 ml-2">
            <button className="BtnSrcFour" onClick={handleSearch}>
              Search
            </button>
            <button className="BtnClearFour ml-5" onClick={handleClear}>
              Clear
            </button>
          </div>
        </div>
      )}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <ApplicationList applications={allApplications} />
      )}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

function ApplicationList({ applications }) {
  return (
    <div>
      <div class=" overflow-x-auto">
        <table class="w-full text-sm text-left text-gray-200 dark:text-gray-400">
          <thead class="border-4 border-gray-300">
            <tr>
              <th
                scope="col"
                class="px-6 py-3 w-full border-r-4 border-gray-200"
              >
                <h1 className="TableHeaderText">Id</h1>
              </th>
              <th
                scope="col"
                class="px-6 py-3 w-full border-r-4 border-gray-200"
              >
                <h1 className="TableHeaderText">Email</h1>
              </th>
              <th
                scope="col"
                class="px-12 py-3 w-full border-r-4 border-gray-200"
              >
                <h1 className="TableHeaderText">Name</h1>
              </th>
              <th scope="col" class="px-6 py-3 border-r-4 border-gray-200">
                <h1 className="TableHeaderText">Gender</h1>
              </th>

              <th scope="col" class="px-6 py-3 border-r-4 border-gray-200">
                <h1 className="TableHeaderText">Religion</h1>
              </th>

              <th scope="col" class="px-6 py-3 border-r-4 border-gray-200">
                <h1 className="TableHeaderText">City</h1>
              </th>
              <th scope="col" class="px-6 py-3 border-r-4 border-gray-200">
                <h1 className="TableHeaderText ">Area</h1>
              </th>
              <th scope="col" class="px-6 py-3 border-r-4 border-gray-200">
                <h1 className="TableHeaderText">HSC</h1>
              </th>
              <th scope="col" class="px-16 py-3 border-r-4 border-gray-200">
                <h1 className="TableHeaderText">Honors</h1>
              </th>
              <th scope="col" class="px-16 py-3 border-r-4 border-gray-200">
                <h1 className="TableHeaderText">Masters</h1>
              </th>
              <th scope="col" class="px-6 py-3 border-r-4 border-gray-200">
                <h1 className="TableHeaderText">Details</h1>
              </th>
            </tr>
          </thead>
          {applications.map((all, index) => (
            <tbody
              key={index}
              className="w-full text-sm text-left text-gray-500 dark:text-gray-400"
            >
              <tr class="bg-white dark:bg-gray-800">
                <th
                  scope="row"
                  class="px-2 border-l-4 border-r-4 border-b border-gray-200 w-full tableBodyText dark:text-white"
                >
                  {all._id.slice(-6)}
                </th>
                <th
                  scope="row"
                  class="px-2 border-l-4 border-r-4 border-b border-gray-200 w-full tableBodyText dark:text-white"
                >
                  {all.email}
                </th>
                <th
                  scope="row"
                  class="px-2 border-l-4 border-r-4 border-b border-gray-200 w-full tableBodyText dark:text-white"
                >
                  {all.name}
                </th>
                <th
                  scope="row"
                  class="px-6 py-4  border-r-4 border-b border-gray-200 tableBodyText dark:text-white"
                >
                  {all.gender}
                </th>
                <td class="px-2 py-4 border-r-4 border-b border-gray-200 tableBodyText ">
                  {all.religion}{" "}
                  {/* {new Date(all.joiningDate).toLocaleDateString("en-GB")} */}
                </td>
                <td class="px-2 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                  {all.city}
                </td>
                <td class="px-4 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                  {all.area}
                </td>
                <td class="px-2 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                  {all.HSCgroup}
                </td>
                <td class="px-1 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                  {all.HonsMajor} {all.HonsInstitute ? "|" : ""}{" "}
                  {all.HonsInstitute} {all.HonsSemester ? "|" : ""}{" "}
                  {all.HonsSemester}
                </td>
                <td class="px-1 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                  {all.MastersMejor} {all.MastersInstitute ? "|" : ""}{" "}
                  {all.MastersInstitute} {all.MastersSemester ? "|" : ""}{" "}
                  {all.MastersSemester}
                </td>
                <td class="px-6 py-4 border-r-4 border-b border-gray-200 tableBodyText">
                  <Link
                    to={`/dashboardTwo/AdminTutorDatabaseDetails/${all._id}`}
                  >
                    <button className="btnView">View</button>
                  </Link>
                </td>
              </tr>
            </tbody>
          ))}
        </table>
      </div>
    </div>
  );
}

function Pagination({ currentPage, totalPages, onPageChange }) {
  const maxPageNumbersToShow = 5;
  let startPage, endPage;

  if (totalPages <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPages;
  } else {
    const maxPagesBeforeCurrentPage = Math.floor(maxPageNumbersToShow / 2);
    const maxPagesAfterCurrentPage = Math.ceil(maxPageNumbersToShow / 2) - 1;
    if (currentPage <= maxPagesBeforeCurrentPage) {
      startPage = 1;
      endPage = maxPageNumbersToShow;
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      startPage = totalPages - maxPageNumbersToShow + 1;
      endPage = totalPages;
    } else {
      startPage = currentPage - maxPagesBeforeCurrentPage;
      endPage = currentPage + maxPagesAfterCurrentPage;
    }
  }

  const pages = Array.from(
    { length: endPage + 1 - startPage },
    (_, i) => startPage + i
  );

  return (
    <nav aria-label="Page navigation example">
      <div className="flex justify-center items-center my-5">
        <button
          className={`mx-5 rounded-lg px-4 text-white ${
            currentPage === 1 ? "bg-gray-200" : "bg-orange-500"
          }`}
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
        >
          Prev
        </button>
        <span className="tableBodyText">
          {" "}
          Page {currentPage} of {totalPages}{" "}
        </span>
        <button
          className="mx-5 bg-orange-500 rounded-lg px-4 text-white"
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </nav>
  );
}

export default TutorDatabaseAdminTwo;
